import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../app/hooks";
import { downloadPortalExport } from "../../features/portal/slice-extensions/portal-me-slice-extension";

interface Props {
  memberId: string;
  firstName: string;
  isSelf: boolean;
}

/** Your data: the member's own GDPR copy (Art. 15/20), the same payload the school can produce. */
const PortalExportCard = ({ memberId, firstName, isSelf }: Props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);

  const download = async () => {
    setBusy(true);
    setError(false);
    try {
      await dispatch(downloadPortalExport({ memberId, firstName, isSelf })).unwrap();
    } catch {
      setError(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="with-border rounded-2xl bg-white p-4 dark:bg-primary-10">
      <h2 className="text-base font-semibold text-grey-20 dark:text-white">{t("portal.me.dataTitle")}</h2>
      <p className="mt-1 text-sm text-grey-40 dark:text-grey-80">{t("portal.me.exportNote")}</p>
      <button type="button" className="btn btn-secondary mt-3" disabled={busy} onClick={download}>
        {busy ? t("portal.me.exporting") : t("portal.me.export")}
      </button>
      {error && <p className="field-error mt-2">{t("portal.me.exportFailed")}</p>}
    </div>
  );
};

export default PortalExportCard;
